import { render } from "./TournamentRow.vue?vue&type=template&id=7d8c162e"
import script from "./TournamentRow.vue?vue&type=script&lang=js"
export * from "./TournamentRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__